module.exports = "//d274d294w9cx2v.cloudfront.net/f4be73f4a6a414bd66b195268a0b7c1a44fd9ffb/images/registryDefaultSmall.webp";